import React, { useCallback } from 'react';
import { RouteChildrenProps } from 'react-router';
import { connect } from 'react-redux';
import {
  selectRow,
  selectRowByRowIndex,
} from '@client-shared/ui-agGrid';

import Routes from '../../../routes';

import { ScenarioObligation, useScenarioMetadata } from '../../../shared/queries/scenarios';
import ScenarioManagerObligationsGrid from './ScenarioManageObligationsGrid.component';
import { DeleteModalData } from '../scenarioManageMembers/types';
import { modalDataSelector } from '../../../shared/modals/modals.selectors';
import { hideDeleteScenarioObligationModal } from './store/actions';
import { MODAL_NAMES } from './constants';
import Spinner from '../../../shared/spinner.component';
import { fromSearchString } from '../../../shared/urlUtils';
import Button from '../../../shared/button.component';

type ScenarioManageObligationsPageProps = {
  clientId: number,
  selectRow: typeof selectRow,
  selectRowByRowIndex: typeof selectRowByRowIndex,
  deleteScenarioObligationData: DeleteModalData<ScenarioObligation>,
  hideDeleteScenarioObligationModal: () => void,
} & RouteChildrenProps<{ scenarioId: string }, { companyCode?: string }>

const ScenarioManageObligationsPage = ({
  match,
  history,
  location,
  clientId,
  selectRow,
  selectRowByRowIndex,
  deleteScenarioObligationData,
  hideDeleteScenarioObligationModal,
}: ScenarioManageObligationsPageProps) => {
  const scenarioId = match!.params!.scenarioId;
  const companyCode = fromSearchString(location.search)?.companyCode;

  const navigateToScenario = useCallback(() => {
    history.push(Routes.scenarios.MEMBERS_LIST.replace(/:scenarioId/, scenarioId));
  }, [history, scenarioId]);

  const {
    data: scenarioMetadata,
  } = useScenarioMetadata({ scenarioId: Number(scenarioId) });

  return (
    <div className="scenario-add-member-list ag-grid-full-page-with-secondary-menu with-editable-grid">
      <div className="page">
        <div className="container-fluid">
          <div className="row no-gutters py-3 d-flex align-items-center">
            <div className="d-flex flex-row">
              <Button
                onClick={navigateToScenario}
                kind="secondary"
              >
                Back to scenario
              </Button>
              <h5 className="ml-3"> Manage obligations - { scenarioMetadata ? scenarioMetadata?.scenarioName : <Spinner small className={'spinner-no-margin'}/> }</h5>
            </div>
          </div>
          <div>
            <ScenarioManagerObligationsGrid
              scenarioId={Number(scenarioId)}
              clientId={Number(clientId)}
              selectRow={selectRow}
              selectRowByRowIndex={selectRowByRowIndex}
              deleteModalData={deleteScenarioObligationData}
              hideDeleteScenarioObligationModal={hideDeleteScenarioObligationModal}
              navigateToScenario={navigateToScenario}
              companyCode={companyCode}
            />
          </div>
        </div>
      </div>
    </div>);
};

const mapStateToProps = (state: any) => ({
  deleteScenarioObligationData: modalDataSelector(state, MODAL_NAMES.DeleteScenarioObligationModal),
});

export default connect(mapStateToProps, {
  selectRow,
  selectRowByRowIndex,
  hideDeleteScenarioObligationModal,
})(
  ScenarioManageObligationsPage
);
